'use client'

import ContactHeroMap from '../../../blocks/ContactHeroMap'
import DemonstrationFormHero from '../../../blocks/DemonstrationFormHero'
import Divider from '../../../blocks/Divider'
import HeroBackgroundImage from '../../../blocks/HeroBackgroundImage'
import HeroBackgroundVideo from '../../../blocks/HeroBackgroundVideo'
import LargeHeroImage from '../../../blocks/LargeHeroImage'
// import MapFullWidth from '../../../components/map/map-full-width'
import SuperHeadingHero from '../../../blocks/SuperHeadingHero'
import TelesoftHeroMap from '../../../blocks/TelesoftHeroMap'
import LeadCapture from '../../../components/LeadCapture'
import ButtonsOverlayImageHero from '../../blocks/ButtonsOverlayImageHero'
import { Page } from '@telesoft/types/payload-types'
import React, { Fragment } from 'react'

const blockComponents = {
  'buttons-overlay-image-hero': ButtonsOverlayImageHero,
  'contact-hero-map': ContactHeroMap,
  'demonstration-form-hero': DemonstrationFormHero,
  'hero-background-image': HeroBackgroundImage,
  'hero-background-video': HeroBackgroundVideo,
  'large-hero-image': LargeHeroImage,
  'lead-capture': LeadCapture,
  'super-heading-hero': SuperHeadingHero,
  'telesoft-hero-map': TelesoftHeroMap,

  // TODO: fix window not defined issue: https://stackoverflow.com/questions/77658930/having-referenceerror-window-is-not-defined-error-for-react-leaflet-during-buil
  // 'map-full-width': MapFullWidth,

  // TODO: fix these heros
  // 'hero-v2': HeroV2,
  // 'hero-slider-fullscreen': HeroSliderFullscreen,
  // 'telesoft-hero-city': TelesoftHeroCity,
  // 'telesoft-hero-map': TelesoftHeroMap,
}

type Props = {
  blocks: Page['hero']
}

export const RenderHeroBlock: React.FC<Props> = props => {
  const { blocks } = props
  const hasBlocks = blocks && Array.isArray(blocks) && blocks.length > 0

  if (hasBlocks) {
    return (
      <Fragment>
        {blocks.map((block, index) => {
          const { blockName, blockType } = block

          if (blockType && blockType in blockComponents) {
            const Block = blockComponents[blockType]

            if (Block) {
              return (
                <Fragment key={`${blockName}--${index}`}>
                  <Block id={blockName as never | string} {...block} />
                  <Divider />
                </Fragment>
              )
            }
          }
          return null
        })}
      </Fragment>
    )
  }

  return null
}
